import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import FeatureFlag from '../../Features/components/FeatureFlag';
import { FeatureFlags } from '../../Features/lib/constants';
import { RemoteControlView } from '../../RemoteControl';

// V2AppChrome supplies the shell and theme; both interfaces use the same controls.
export default function RemoteControlV2() {
    return (
        <FeatureFlag
            flag={FeatureFlags.REMOTE_CONTROL_V1}
            fallback={() => <Navigate to="/v2/devices" replace />}
        >
            <main>
                <h1 className="sr-only">Remote control</h1>
                <div className="mx-auto max-w-6xl px-4 pt-4">
                    <Link to="/v2/devices" className="text-sm font-semibold text-brand-ink">
                        ← Back to Devices
                    </Link>
                </div>
                <RemoteControlView />
            </main>
        </FeatureFlag>
    );
}
